import angular from 'angular';

module.exports = angular.module('common.directives', [
  require('./comma-number'),
  require('./confirm'),
  require('./convert-to-number'),
  require('./currency'),
  require('./decimal-to-percent'),
  require('./details-map'),
  require('./dropdown-multiselect'),
  require('./empty-to-null'),
  require('./icon'),
  require('./image-background'),
  require('./infinite-scroll'),
  require('./inject-to-transclusion-scope'),
  require('./inline-uploads'),
  require('./inspections'),
  require('./isolate-form'),
  require('./login-link'),
  require('./min-max'),
  require('./number-range'),
  require('./od-comps-map'),
  require('./od-lazy-element'),
  require('./od-photo-tooltip'),
  require('./od-press'),
  require('./od-scroll-stay'),
  require('./od-sneaky-element'),
  require('./od-star-rating'),
  require('./od-testimonial-block'),
  require('./od-tooltip'),
  require('./pager'),
  require('./percent'),
  require('./percent-int'),
  require('./photos'),
  require('./pikaday'),
  require('./place-autocomplete'),
  require('./redux-mapping'),
  require('./render-once'),
  require('./select-all-on-focus'),
  require('./service_account_indicators'),
  require('./table-frozen'),
  require('./table-sortable'),
  require('./tel'),
  require('./title'),
  require('./xhr-progress'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/index.js
 **/